export const MCAT_TEST_TYPE = "MCAT";
export const ACT_TEST_TYPE = "ACT";
export const LSAT_TEST_TYPE = "LSAT";
export const GRE_TEST_TYPE = "GRE";
export const GMAT_TEST_TYPE = "GMAT";
export const SAT_TEST_TYPE = "SAT";